<template>
	<div class="controls-button">
		<div class="start" :class="{ 'disabled': isDisabledStart }" @click="start"></div>
		<div class="previous" :class="{ 'disabled': isDisabledPrevious }" @click="previous"></div>
		<div class="next" ref="next" :class="{ 'disabled': isDisabledNext }" @click="next"></div>
	</div>
</template>

<script>
export default {
	name: 'ControlsButton',
	inject: ['helpers'],
	props: {
		data: Array,
	},
	data() {
		return {
			isDisabledStart: true,
			isDisabledPrevious: true,
			isDisabledNext: false,
			rememberDistans: {}
		}
	},
	methods: {
		start() {
			this.helpers.enableScrolling();
			this.isDisabledNext = false;
			this.isDisabledPrevious = true;

			window.scrollTo({ top: 0 });
		},
		previous() {
			const pos = window.scrollY;
			const index = this.data.findIndex(item => item.scrollDistance >= pos);
			const last = this.data[this.data.length - 1];

			this.helpers.enableScrolling();

			if (last.scrollDistance <= pos) {
				window.scrollTo({ top: last.previous });
				this.isDisabledNext = false;
				return;
			}

			if (index !== false) {
				if(index === 0) {
					window.scrollTo({ top: 0 });
				} else {
					window.scrollTo({ top: this.data[index - 1].scrollDistance });
				}

			}
		},
		next() {
			const pos = window.scrollY;
			const distance = this.data.find(item => item.scrollDistance > pos);

			this.isDisabledPrevious = false;
			this.helpers.enableScrolling();

			if (this.$refs.next.classList.contains('pulse')) {
				this.$refs.next.classList.remove('pulse');
			}
			window.scrollTo({ top: distance.scrollDistance });
		},
		handleScroll(event) {
			const pos = window.scrollY;
			const distance = this.data.find(item => item.scrollDistance > pos);
			const last = this.data[this.data.length - 1];

			if (last.scrollDistance <= pos) {
				this.isDisabledPrevious = false;
				this.isDisabledNext = true;
				this.isDisabledStart = false;
				return;
			}

			if (pos >= distance.start && pos < distance.scrollDistance) {
				if (this.$navigate.value === false) {
					window.scrollTo({
						top: distance.start,
						// behavior: "smooth"
					})
				}
				this.helpers.disableScrolling();

				if (!this.$refs.next.classList.contains('pulse')) {
					this.$refs.next.classList.add('pulse');
					this.isDisabledNext = false;
				}
			}


			if (pos > 0) this.isDisabledStart = false;
			this.isDisabledPrevious = distance.previous === 0;
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	}
}
</script>

<style lang="scss" scoped>
.controls-button {
	width: 70px;
	height: 300px;
	position: fixed;
	top: 50%;
	right: 100px;
	background: rgba(0, 0, 0, .5);
	border-radius: 22px;
	transform: translateY(-50%);
	display: flex;
	flex-direction: column;
	z-index: 20;

	.start,
	.previous,
	.next {
		height: 33.33%;
		width: 100%;
		cursor: pointer;
		position: relative;

		&:before {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			opacity: 0;
			transition: all 0.3s;
		}

		&:after {
			content: '';
			display: block;
			width: 45px;
			height: 1px;
			background: #666666;
			position: absolute;
			top: 100%;
			left: 50%;
			transform: translateX(-50%);
		}

		&:hover:before {
			opacity: 1;
		}

		&.disabled {
			pointer-events: none;
			filter: brightness(0.5);
		}
	}

	.next:after {
		display: none;
	}

	.start {
		background: url(/themes/rise-theme/dist/images/estate/button-startover.png) no-repeat center;
		background-size: 39px;

		&:before {
			background: url(/themes/rise-theme/dist/images/estate/button-startover-hover.png) no-repeat center 1px;
			background-size: 71px;
		}
	}

	.previous {
		background: url(/themes/rise-theme/dist/images/estate/button-previous.png) no-repeat center;
		background-size: 55px;

		&:before {
			background: url(/themes/rise-theme/dist/images/estate/button-previous-hover.png) no-repeat center -2.5px;
			background-size: 69px;
		}
	}

	.next {
		background: url(/themes/rise-theme/dist/images/estate/button-next.png) no-repeat center;
		background-size: 48px;

		&:before {
			background: url(/themes/rise-theme/dist/images/estate/button-next-hover.png) no-repeat 2px 2px;
			background-size: 67px;
		}
	}

	@media(min-width: 650px) {
		.pulse {
			animation: pulse_desktop 0.8s ease-in infinite;
		}
	}

	@media(max-width: 650px) {
		.pulse {
			animation: pulse_mobile 0.8s ease-in infinite;
		}
	}

	@keyframes pulse_desktop {
		45% {
			transform: scale(0.9);
		}

		65% {
			transform: scale(1.2);
		}
	}
	@keyframes pulse_mobile {
		45% {
			transform: scale(0.9) rotate(90deg);
		}

		65% {
			transform: scale(1.2) rotate(90deg);
		}
	}
}

@media screen and (max-width: 1600px) {
	.controls-button {
		zoom: 0.8;
		right: 50px;
	}
}

@media screen and (max-width: 1280px) {
	.controls-button {
		zoom: 0.7;
		right: 30px;
	}
}

@media screen and (max-width: 650px) {
	.controls-button {
		right: initial;
		top: initial;
		left: 50%;
		bottom: 115px;
		height: 250px;
		width: 80px;
		zoom: 0.8;
		transform-origin: center;
		transform: translateY(0) translateX(-50%) rotate(-90deg);

		.start,
		.previous,
		.next {
			transform-origin: center;
			transform: rotate(90deg);

			&:before {
				display: none;
			}

			&:after {
				width: 1px;
				height: 45px;
				left: 100%;
				top: 50%;
				transform: translateY(-50%);
			}
		}
	}
}
</style>
